export async function getGoogleAnalyticsClientId(timeout: number): Promise<string> {
  window.dataLayer = window.dataLayer || [];
  const gtag: Gtag.Gtag = function () {
    window.dataLayer.push(arguments);
  };

  return Promise.race([
    new Promise<string>((resolve) => {
      if (process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID) {
        gtag('get', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID, 'client_id', function (clientId) {
          resolve(String(clientId));
        });
      }
    }),
    new Promise<string>((_resolve, reject) => window.setTimeout(reject, timeout)),
  ]);
}
